<template>
	<VRow
		align="start"
	>
		<VCol
			:cols="isSmAndDown ? '12' : ''"
			:class="{
				'icon-box--no-padding': isSmAndDown
			}"
		>
			<div
				class="icon-box"
			>
				<img
					src="@/assets/inscription.svg"
					alt="Je m'inscris"
				>
				<p v-html="text1" />
			</div>
		</VCol>
		<VCol
			:cols="isSmAndDown ? '12' : ''"
			class="icon-box--arrow"
			:class="{
				'icon-box--no-padding d-none': isSmAndDown
			}"
		>
			<img
				src="@/assets/fleche.svg"
			>
		</VCol>
		<VCol
			:cols="isSmAndDown ? '12' : ''"
			:class="{
				'icon-box--no-padding': isSmAndDown
			}"
		>
			<div class="icon-box">
				<img
					src="@/assets/questionnaire.svg"
					alt="Je réponds au questionnaire et ajoute des documents"
				>
				<p>{{ text2 }}</p>
			</div>
		</VCol>
		<VCol
			:cols="isSmAndDown ? '12' : ''"
			class="icon-box--arrow"
			:class="{
				'icon-box--no-padding d-none': isSmAndDown
			}"
		>
			<img
				src="@/assets/fleche.svg"
			>
		</VCol>
		<VCol
			:cols="isSmAndDown ? '12' : ''"
			:class="{
				'icon-box--no-padding': isSmAndDown
			}"
		>
			<div class="icon-box">
				<img
					src="@/assets/dossier.svg"
					alt="Icone dossier"
				>
				<p>{{ text3 }}</p>
			</div>
		</VCol>
		<VCol
			:cols="isSmAndDown ? '12' : ''"
			class="icon-box--arrow"
			:class="{
				'icon-box--no-padding d-none': isSmAndDown
			}"
		>
			<img
				src="@/assets/fleche.svg"
			>
		</VCol>
		<VCol
			:cols="isSmAndDown ? '12' : ''"
			:class="{
				'icon-box--no-padding': isSmAndDown
			}"
		>
			<div class="icon-box">
				<img
					src="@/assets/commentaire.svg"
					:alt="$t('views.homeUser.common.icons.comment')"
				>
				<p>{{ text4 }}</p>
			</div>
		</VCol>
		<VCol
			:cols="isSmAndDown ? '12' : ''"
			class="icon-box--arrow"
			:class="{
				'icon-box--no-padding d-none': isSmAndDown
			}"
		>
			<img
				src="@/assets/fleche.svg"
			>
		</VCol>
		<VCol
			:cols="isSmAndDown ? '12' : ''"
			:class="{
				'icon-box--no-padding ': isSmAndDown
			}"
		>
			<div class="icon-box">
				<img
					src="@/assets/decision.svg"
					:alt="$t('views.homeUser.common.icons.decision')"
				>
				<p>{{ text5 }}</p>
			</div>
		</VCol>
	</VRow>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component, { mixins } from 'vue-class-component';
	import { mapState } from 'vuex';

	const Props = Vue.extend({
		props: {
			'text1': {
				type: String,
				required: true
			},
			'text2': {
				type: String,
				required: true
			},
			'text3': {
				type: String,
				required: true
			},
			'text4': {
				type: String,
				required: true
			},
			'text5': {
				type: String,
				required: true
			}
		}
	});

	const MixinsDeclaration = mixins(Props);

	@Component<HowItWorkProcess>({
		computed: mapState('appState', ['user'])
	})
	export default class HowItWorkProcess extends MixinsDeclaration {

		get isSmAndDown(): boolean {
			return this.$vuetify.breakpoint.smAndDown;
		}
	}
</script>

<style scoped lang="scss">
.icon-box {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	gap: 1rem;
	min-width: 150px;

	p {
		color: #0C419A;
		font-weight: 500;
	}

	&--arrow {
		margin-top: 1.3rem;
		justify-content: center;
		display: flex;

		img {
			width: 57px;
		}
	}
}

</style>
